import {ref, unref, computed, watch} from 'vue';
import {defineStore} from 'pinia';
import {useLocalStorage} from '@vueuse/core';
import pinia from '@/znzs/new_src/store/index.js';
import {CHAT_MODE, CHAT_MODE_TYPE} from '@/znzs/new_src/constant';
import {user} from '@/znzs/src/utils/index';
import {isUrlEncoded} from '@/znzs/new_src/utils/index';
import {isIninWhitelist} from '@/znzs/src/api/robot';

export const useCommonStore = defineStore('CommonStore', () => {
    const pageLoading = ref(false);
    const grayCapability = ref(false);
    const chatMode = useLocalStorage('__ZNZS_CHAT_MODE', {
        type: CHAT_MODE.NORMAL,
    });
    // pageSource在非IM场景下使用一次之后会清空，tracePageSource不会
    const pageSource = useLocalStorage('__ZNZS_PAGE_SOURCE', '');
    const tracePageSource = useLocalStorage('__ZNZS_TRACE_PAGE_SOURCE', unref(pageSource));
    const isNormalChat = computed(() => unref(chatMode).type === CHAT_MODE.NORMAL);
    const isQFChat = computed(() => unref(chatMode).type === CHAT_MODE.QF);
    const chatModeType = computed(() => {
        if (unref(isNormalChat)) {
            return CHAT_MODE_TYPE.ROBOT;
        }
        return CHAT_MODE_TYPE.SOCKET;
    });

    watch(pageSource, value => {
        if (value) {
            tracePageSource.value = value;
        }
    });

    function setPageSource(source = '') {
        if (!source) {
            pageSource.value = '';
            return;
        }
        pageSource.value = isUrlEncoded(source) ? decodeURIComponent(source) : source;
    }

    async function getGrayCapability() {
        try {
            const res = await isIninWhitelist({scene: 'BETA_VERSION'});
            grayCapability.value = res?.data?.inWhiteList;
        }
        catch {

        }
    }

    return {
        pageLoading,
        pageSource,
        tracePageSource,
        chatMode,
        isNormalChat,
        isQFChat,
        chatModeType,
        user,
        setPageSource,
        grayCapability,
        getGrayCapability,
    };
});

export const useCommonStoreOut = () => useCommonStore(pinia);